export default __webpack_public_path__ + "static/media/podcast-player.4def2bd7.png";